// eslint-disable-next-line import/no-unassigned-import
import './styles/reset.css';

// eslint-disable-next-line import/no-unassigned-import
import './styles/font.css';

// eslint-disable-next-line import/no-unassigned-import
import './styles/main.css';

import { render } from 'preact';
import { App } from './App';

function init(containerClass = '.app__standalone') {
  const container = document.querySelectorAll(containerClass)[0];
  render(<App />, container);
}

window.addEventListener(
  'DOMContentLoaded',
  function () {
    init();
  },
  false
);
